// extracted by mini-css-extract-plugin
export default {"deleteAllWrapper":"SpreadsheetList_deleteAllWrapper__reeZv","mobileActions":"SpreadsheetList_mobileActions__HeCTJ"};